import React, { PureComponent } from 'react'
import { Radar, RadarChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis, ResponsiveContainer, Rectangle, Legend, Tooltip, Cell } from 'recharts';
import { BOUND_COLORS, formatCurrency } from '../functions';

const mockdata = [
    {
        subject: 'Vendedor 1',
        vendas: 120,
    },
    {
        subject: 'Vendedor 2',
        vendas: 220,
    },
    {
        subject: 'Vendedor 3',
        vendas: 110,
    },
    {
        subject: 'Vendedor 4',
        vendas: 80,
    },
    {
        subject: 'Vendedor 5',
        vendas: 80,
    },
    {
        subject: 'Vendedor 6',
        vendas: 80,
    },
    {
        subject: 'Vendedor 7',
        vendas: 80,
    },
    {
        subject: 'Vendedor 8',
        vendas: 80,
    },
    {
        subject: 'Vendedor 9',
        vendas: 80,
    },
    {
        subject: 'Vendedor 10',
        vendas: 80,
    },
];


const getEntryColor = (entry, vx) =>
    BOUND_COLORS[String(entry?.[vx || 'name'])] || BOUND_COLORS[String(entry?.owner_name)]

const JourneyPoligonChart = ({ data, vx, vy, renderValue }) => {

    return (
        <ResponsiveContainer width="100%" height="100%">
            <RadarChart cx="50%" cy="50%" outerRadius="80%" data={data || mockdata}>
                <PolarGrid />
                <PolarAngleAxis dataKey={vx || 'name'} />
                <PolarRadiusAxis tickFormatter={(value) => {
                    if (vy === 'duration')
                        return convert_seconds(value)
                    else if (vy === 'conversion')
                        return `${value} %`
                    else if (vy === 'value')
                        return renderValue ? renderValue(vy, { ...data[0], value: String((value || 0)) }) : formatCurrency(String((value || 0)))
                    return value
                }}
                />
                <Radar
                    legendType="rect"
                    dataKey={vy || 'count'} stroke="#8884d8" fill="#8884d8" fillOpacity={0.6} activeBar={<Rectangle fill="pink" stroke="blue" />}>
                    {data.map((entry, index) => (
                        <Cell key={`cell-${index}`} fill={getEntryColor(entry, vx)} />
                    ))}
                </Radar>
                <Tooltip formatter={(value, name, { payload }) => [renderValue ? renderValue(vy, payload) : '', 'Total']} />
            </RadarChart>
        </ResponsiveContainer>
    );
}


export default JourneyPoligonChart
